import React from 'react'
import { Outlet } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';


import LandingHeader from './components/header/LandingHeader';
import LandingFooter from './components/footer/LandingFooter';

const LandingLayout = () => {
  return (
    <>
      <ToastContainer/>
      <LandingHeader/>
      <div className="has-smooth" id="has_smooth"></div>
      <div className='tv-body' id="smooth-wrapper">
        <div id="smooth-content">
          <div className="body-wrapper body-booking">
            <div className="overlay-switcher-close"></div>
              <Outlet/>
              <LandingFooter/>
          </div>
        </div>
      </div>
    </>
  )
}

export default LandingLayout